<template>
    <div class="pb-table-wrap">
        <div class="table-responsive">
            <table class="table pb-table">
                <thead>
                    <tr>
                        <th class="text-center">#</th>
                        <th>Product</th>
                        <th>Batch</th>
                        <th>Mfg. Date</th>
                        <th>Exp. Date</th>
                        <th class="text-end">S. Rate</th>
                        <th class="text-end">P. Rate</th>
                        <th class="text-end">Qty</th>
                        <th class="text-end">Discount</th>
                        <th>VAT/GST Type</th>
                        <th class="text-end">VAT/GST</th>
                        <th class="text-end">Total</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in itemDetails" :key="index" :class="{ 'pb-row--editing': isEditingRow(index) }">
                        <td class="text-center pb-serial">{{ index + 1 }}</td>
                        <td class="pb-product">{{ item.product_name }}</td>
                        <td>{{ item.batch_number }}</td>
                        <td>{{ item.mfn_date }}</td>
                        <td>{{ item.exp_date }}</td>
                        <td class="text-end">{{ item.selling_rate }}</td>
                        <td class="text-end">{{ item.rate }}</td>
                        <td class="text-end">{{ item.quantity }}</td>
                        <td class="text-end">{{ discountText(item) }}</td>
                        <td>{{ taxRateName(item) }}</td>
                        <td class="text-end">{{ item.vat_amount || '' }}</td>
                        <td class="text-end pb-total">{{ item.g_total }}</td>
                        <td class="text-center">
                            <div class="pb-row-actions">
                                <button type="button" class="btn btn-sm btn-outline-primary" title="Edit" @click="handleEditItem(item, index)">
                                    <i class="fa-solid fa-pen"></i>
                                </button>
                                <button type="button" class="btn btn-sm btn-outline-danger" title="Remove" @click="$emit('removeBill', index)">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="! hasItems" class="pb-empty">
            <i class="fa-solid fa-box-open pb-empty-icon"></i>
            <div class="pb-empty-title">No products added yet</div>
            <div class="pb-empty-text">Fill in the product line above, then press Add or Enter.</div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue'

    const props = defineProps({
        itemDetails: {
            type: Array,
            default: []
        },
        formRef: {
            type: Object,
        }
    })

    const hasItems = computed(() => Array.isArray(props.itemDetails) && props.itemDetails.length > 0)

    const handleEditItem = (item, index) => {
        props.formRef.setData(item)
        props.formRef.updateIndex = index;
    }

    const isEditingRow = (index) => {
        if (! props.formRef) return false;
        return props.formRef.updateIndex === index;
    }

    const discountText = (item) => {
        if (! item.discount_percent) return '';
        return `${item.discount_percent}%`;
    }

    const taxRateName = (item) => {
        if (! item.tax_rate) return '';
        return item.tax_rate.name;
    }
</script>

<style scoped>
.pb-table-wrap {
    margin-top: 1rem;
    border: 1px solid #eef1f6;
    border-radius: 10px;
    overflow: hidden;
}
.pb-table {
    margin-bottom: 0;
}
.pb-table thead th {
    color: #000;
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.3px;
    white-space: nowrap;
    padding: 0.6rem 0.75rem;
    border-bottom: 1px solid #eef1f6;
}
.pb-table td {
    padding: 0.55rem 0.75rem;
    color: #000;
    white-space: nowrap;
    vertical-align: middle;
    border-color: #eef1f6;
}
.pb-table tbody tr:hover {
    background: #fafbff;
}
.pb-table tbody tr.pb-row--editing {
    background: #eef4ff;
}
.pb-table td.pb-serial {
    color: #6e6b7b;
}
.pb-table td.pb-product {
    min-width: 180px;
    font-weight: 600;
    white-space: normal;
}
.pb-total {
    font-weight: 600;
}
.pb-row-actions {
    display: inline-flex;
    gap: 0.35rem;
}
.pb-row-actions .btn {
    padding: 0.3rem 0.5rem;
    border-radius: 6px;
}
.pb-empty {
    padding: 1.25rem 0.75rem;
    text-align: center;
}
.pb-empty-icon {
    font-size: 1.4rem;
    color: #c7cbd4;
}
.pb-empty-title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #000;
}
.pb-empty-text {
    font-size: 0.8rem;
    color: #6e6b7b;
}
</style>
